export interface FeatureCard {
    title: string;
    body: string;
    accent?: boolean;
}

export interface FeatureGridProps {
    sectionTitle: string;
    sectionLead: string;
    cards: readonly FeatureCard[];
    /** An anchor target (the top bar's How it works -> #how-it-works on the landing). */
    id?: string;
}

/** Three-column (responsive) grid of feature cards with a section heading. */
export function FeatureGrid({ sectionTitle, sectionLead, cards, id }: FeatureGridProps) {
    return (
        <section className="mktg-features" id={id}>
            <div className="mktg-container">
                <h2 className="mktg-section-title">{sectionTitle}</h2>
                <p className="mktg-section-lead">{sectionLead}</p>
                <div className="mktg-feature-grid">
                    {cards.map((card, i) => (
                        <div
                            key={i}
                            className={`mktg-feature-card${card.accent ? ' mktg-feature-card--accent' : ''}`}
                        >
                            <h3 className="mktg-feature-card__title">{card.title}</h3>
                            <p className="mktg-feature-card__body">{card.body}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
